export enum DocumentListEnum {
    EXECUTION_AIR = 1,
    PROTOCOL_AIR = 2,
    EXECUTION_THERMAL = 3,
    PROTOCOL_THERMAL = 4,
    CHARACTERIZATION = 5,
    CALIBRATES = 6,
    PROTOCOL_QUALIFICATES = 7,
    EXECUTION_QUALIFICATES = 8,
    ANNUAL_CALIBRATION = 9
}